import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import { withRouter} from 'react-router-dom';
import {getAdminEmpresa, getOperadorRemarcacao, PERFIL_ADMIN} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import {apenasNumero, renderFieldCpf, renderFieldNumber} from '../../util/inputs';
import Titulo from '../comum/Titulo';
import buscarPedidoRemarcacao from '../../actions/remarcacao/buscarReservasRemarcacao';
import alterarMarcacaoReserva from '../../actions/remarcacao/alterarMarcacaoReserva';
import limparReservasRemarcacao from '../../actions/remarcacao/limparReservasRemarcacao';
import selecionarReservasRemarcacao from '../../actions/remarcacao/selecionarReservasRemarcacao';
import limpaViagens from '../../actions/viagem/limpaViagens';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import adicionarPassageirosIda from '../../actions/passageiro/adicionarPassageirosIda'
import adicionarPassageirosVolta from '../../actions/passageiro/adicionarPassageirosVolta';
import selecionarDescontoUsuario from '../../actions/desconto/selecionarValorDescontoCalculado';
import { adicionarFormasPagamento } from '../../actions/viagem/adicionarFormasPagamento';
import Remarcacao from './Remarcacao';
import ModalConfirmacaoCancelamentoReserva from './ModalConfirmacaoCancelamentoReserva';
import ModalConfirmacaoReservaEmAberto from './ModalConfirmacaoReservaEmAberto';
import {groupArrayOfObjects} from '../../util/arraysUtil';
import selecionarViagemIda from '../../actions/viagem/selecionarViagemIda';
import selecionarViagemVolta from '../../actions/viagem/selecionarViagemVolta';
import {showErrorMsg} from '../../util/messagesUtil';
import ModalConfirmacaoCancelamentoSeguro from './ModalConfirmacaoCancelamentoSeguro';
import ModalConfirmacaoReservasSolicitacaoReembolso from './ModalConfirmacaoReservasSolicitacaoReembolso';
import ModalConfirmacaoReservasParaReembolsoEfetivado from './ModalConfirmacaoReservasParaReembolsoEfetivado';
import ModalAnexaDocumentoReservasParaReembolsoEfetivado from './ModalAnexaDocumentoReservasParaReembolsoEfetivado';
import selecionaReservaReembolsoSolicitado from '../../actions/reserva/selecionaReservaReembolsoSolicitado';

const selector = formValueSelector('formRemarcacao');

const tipoBuscaCPF = {
    value: 'CPF',
    label: 'Buscar por CPF'
};

export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-table d-none d-md-block d-sm-none">
        <div className="row cabecalho-desktop">
            <div className="col">Empresa</div>
            <div className="col">Nome</div>
            <div className="col">CPF</div>
            <div className="col">Data de embarque</div>
            <div className="col">Origem/Destino</div>
            <div className="col">Delimitação</div>
            <div className="col">Embarcou</div>
            <div className="col">Situação</div>
            <div className="col">Poltrona</div>
            <div className="col">Ações</div>
        </div>
    </div>
);

export class PainelGerenciarRemarcacao extends React.Component {
    constructor(props) {
        super(props);
        this.montarParametroPedido = this.montarParametroPedido.bind(this);

        this.state = {
            tipoBusca: tipoBuscaCPF,
            custoCancelamento: '0',
            habilitadoZerarValorMultaCancelamento: false
        };
    }

    componentDidMount() {
        this.props.limparReservasRemarcacao();
        this.buscarPedidos();
        this.props.selecionarReservasRemarcacao();
        this.props.selecionaReservaReembolsoSolicitado();
        this.limparTudo()
    }

    handleHabilitadoZerarValorMultaCancelamento(e) {
        this.setState({ habilitadoZerarValorMultaCancelamento: e.target.checked });
    }

    limparHabilitadoZerarValorMultaCancelamento() {
        this.setState({ habilitadoZerarValorMultaCancelamento: false });
    }

    limparTudo() {
        this.setState({abaSelecionada: 1});
        this.props.selecionarDestino(null);
        this.props.selecionarOrigem(null);
        this.props.limpaViagens();
        this.props.selecionarViagemIda();
        this.props.selecionarViagemVolta();
        this.props.adicionarPassageirosIda([]);
        this.props.adicionarPassageirosVolta([]);
        this.props.selecionarReservasRemarcacao(null);
        this.props.adicionarFormasPagamento(null);
        this.props.selecionarDescontoUsuario({
            ida: 0.00,
            volta: 0.00
        })
    }

    buscarPedidos() {
        const parametros = {
            idReserva: this.props.numeroBilhete && this.props.numeroBilhete !== '' ? this.props.numeroBilhete : null,
            idPedido: this.props.numeroPedido && this.props.numeroPedido !== '' ? this.props.numeroPedido.trim() : null,
            cpf: this.props.cpf && this.props.cpf !== '' ? apenasNumero(this.props.cpf) : null,
            idEmpresa: this.props.empresaSelecionada.id,
        }
        this.props.buscarPedidoRemarcacao(parametros)
    }

    limparPesquisas() {
        this.props.limparReservasRemarcacao();
        this.props.selecionarReservasRemarcacao();
    }

    // eslint-disable-next-line class-methods-use-this
    montarParametroPedido(values) {
        return {
            id: values.idPedido,
            nome: values.nome,
            telefones: [values.ddd + values.celular],
            email: values.email
        };
    }

    alterarMarcacao(reserva) {
        const reservasSelecionadas = this.props.reservas.filter(f => f.selecionada);
        if (reservasSelecionadas.length > 0) {
            const pedidoId = reservasSelecionadas[0].pedidoId;
            if (pedidoId === reserva.pedidoId) {
                this.props.alterarMarcacaoReserva(reserva)
            } else {
                showErrorMsg('Selecione reservas do mesmo pedido.');
            }
        } else {
            this.props.alterarMarcacaoReserva(reserva)
        }
    }

    validarReservasConexao() {
        const reservas = this.props.reservas.filter(f => f.selecionada);

        for (const reserva of reservas) {
            if (reserva.idsReservasConexao && reserva.idsReservasConexao.length > 0) {
                const idsReservasConexao = reserva.idsReservasConexao;
                const idsReservasSelecionadas = reservas.map(r => r.id);
                const todasConexoesSelecionadas = idsReservasConexao.every(id => idsReservasSelecionadas.includes(id));

                if (!todasConexoesSelecionadas) {
                    const reservasConexaoNaoSelecionadas = this.props.reservas.filter(r =>
                        idsReservasConexao.includes(r.id) && !r.selecionada
                    );
                    const nomesReservas = reservasConexaoNaoSelecionadas.map(r =>
                        `${r.passageiroDto.nome} (${r.descCidadeOrigem} - ${r.descCidadeDestino})`
                    ).join(', ');
                    showErrorMsg(`Para remarcar reservas com conexão, todas as reservas relacionadas devem ser selecionadas. Faltam: ${nomesReservas}`);
                    return false;
                }
            }
        }

        return true;
    }

    selecionarReservas() {
        const reservas = this.props.reservas.filter(f => f.selecionada);
        this.props.selecionarReservasRemarcacao(reservas)
    }

    navegarParaRemarcacao() {
        if (this.validarReservasConexao()) {
            this.selecionarReservas();
            this.props.history.push('/painel-destinos?remarcacao=s');
        }
    }

    selecionarReservasAlteracaoPoltrona() {
        const reservas = this.props.reservas.filter(f => f.selecionada);
        if (Object.entries(groupArrayOfObjects(reservas, 'itinerarioId')).length > 1) {
            showErrorMsg('Não é permitido alterar poltronas de itinerários diferentes');
            return
        }
        this.props.selecionarReservasRemarcacao(reservas);
        this.props.history.push('/painel-alteracao-poltrona')
    }

    selecionarReservasCancelarSeguro() {
        const reservasSemSeguro = this.props.reservas.filter(f => f.selecionada && !f.numeroSeguro);
        if (reservasSemSeguro.length > 0) {
            showErrorMsg('Existem reservar sem seguro selecionadas para cancelamento');
            return
        }
    }

    exibirReservas() {
        return this.props.reservas
            .map((reserva, index) => <Remarcacao key={reserva.id} reserva={reserva}
                                                 empresaSelecionada={this.props.empresaSelecionada}
                                                 alterarMarcacaoReserva={this.alterarMarcacao.bind(this)}
                                                 indice={index}/>)
    }

    exibirTipoBusca() {
        return (
            <div className="vx-remark-search">
                <div className="vx-remark-search-header">
                    <span className="material-icons" style={{fontSize: '18px', color: '#FF6A00'}}>search</span>
                    Buscar Reservas
                </div>
                <div className="vx-remark-search-body">
                    <div className="vx-remark-search-field" onClick={() => {
                        this.limparPesquisas();
                        this.props.changeFieldValue('formRemarcacao', 'cpf', null);
                        this.props.changeFieldValue('formRemarcacao', 'numeroBilhete', null);
                    }}>
                        <Field name='numeroPedido' type="text" css="form-control"
                               component={renderFieldNumber}
                               onChange={() => this.limparPesquisas()}
                               placeholder="Número do pedido"/>
                    </div>
                    <span className="vx-remark-search-or">ou</span>
                    <div className="vx-remark-search-field" onClick={() => {
                        this.limparPesquisas();
                        this.props.changeFieldValue('formRemarcacao', 'numeroPedido', null);
                        this.props.changeFieldValue('formRemarcacao', 'numeroBilhete', null);
                    }}>
                        <Field name='cpf' type="text" css="form-control"
                               component={renderFieldCpf}
                               onChange={() => this.limparPesquisas()}
                               placeholder="CPF do passageiro"/>
                    </div>
                    <span className="vx-remark-search-or">ou</span>
                    <div className="vx-remark-search-field" onClick={() => {
                        this.limparPesquisas();
                        this.props.changeFieldValue('formRemarcacao', 'cpf', null);
                        this.props.changeFieldValue('formRemarcacao', 'numeroPedido', null);
                    }}>
                        <Field name='numeroBilhete' type="text" css="form-control"
                               component={renderFieldNumber}
                               onChange={() => this.limparPesquisas()}
                               placeholder="Número do bilhete"/>
                    </div>
                    <button type="button" onClick={() => this.buscarPedidos()} className="vx-remark-search-btn">
                        <span className="material-icons" style={{fontSize: '18px'}}>search</span>
                        Buscar
                    </button>
                </div>
            </div>
        );
    }

    exibirBotoes() {
        if (!this.props.reservas) {
            return '';
        }
        const reservasComSeguro = this.props.reservas.filter(f => f.numeroSeguro !== null && f.selecionada);
        const reservaEmAberto = this.props.reservas.filter(f => f.situacaoReserva === 'EM_ABERTO' && f.selecionada);
        const reservaSolicitadoReembolso = this.props.reservas.filter(f => f.situacaoReserva === 'REEMBOLSO_SOLICITADO' && f.selecionada);
        const selecionadas = this.props.reservas.filter(f => f.selecionada);
        const reservasSemSeguroSelecionada = selecionadas.filter(f => f.numeroSeguro === null);

        if (selecionadas.length > 0) {
            return (
                <div className="vx-remark-actions">
                    <div className="vx-remark-actions-info">
                        <span className="material-icons" style={{fontSize: '18px', color: '#FF6A00'}}>check_box</span>
                        {selecionadas.length} reserva(s) selecionada(s)
                    </div>
                    <div className="vx-remark-actions-btns">
                        {reservaEmAberto.length <= 0 ?
                            <button type="button"
                                    className="vx-remark-btn vx-remark-btn-poltrona"
                                    onClick={() => this.selecionarReservasAlteracaoPoltrona()}>
                                <span className="material-icons" style={{fontSize: '16px'}}>event_seat</span>
                                Mudar Poltrona
                            </button> : ''}
                        <button type="button"
                                className="vx-remark-btn vx-remark-btn-remarcar"
                                onClick={() => this.navegarParaRemarcacao()}>
                            <span className="material-icons" style={{fontSize: '16px'}}>edit</span>
                            Remarcar
                        </button>
                        <button type="button"
                                data-toggle="modal"
                                data-target="#modalConfirmacaoCancelamentoReservas"
                                className="vx-remark-btn vx-remark-btn-cancelar">
                            <span className="material-icons" style={{fontSize: '16px'}}>cancel</span>
                            Cancelar
                        </button>
                        {selecionadas.length > 0 && reservaEmAberto.length <= 0 ?
                            <button type="button"
                                    data-toggle="modal"
                                    data-target="#modalConfirmacaoReservasEmAberto"
                                    className="vx-remark-btn vx-remark-btn-aberto">
                                <span className="material-icons" style={{fontSize: '16px'}}>lock_open</span>
                                Deixar aberto
                            </button> : ''}
                        {selecionadas.length > 0 && reservaSolicitadoReembolso.length <= 0 ?
                            <button type="button"
                                    data-toggle="modal"
                                    data-target="#modalConfirmacaoReservasSolicitacaoReembolso"
                                    className="vx-remark-btn vx-remark-btn-reembolso">
                                <span className="material-icons" style={{fontSize: '16px'}}>receipt</span>
                                Solicitar Reembolso
                            </button> : ''}
                        {selecionadas.length > 0 && reservaSolicitadoReembolso.length > 0 ?
                            <button type="button"
                                    data-toggle="modal"
                                    data-target="#modalConfirmacaoReservasParaReembolsoEfetivado"
                                    className="vx-remark-btn vx-remark-btn-reembolso">
                                <span className="material-icons" style={{fontSize: '16px'}}>payment</span>
                                Efetuar Reembolso
                            </button> : ''}
                        {selecionadas.length > 0 && reservasComSeguro.length > 0 && reservasSemSeguroSelecionada.length === 0 ?
                            <button type="button"
                                    data-toggle="modal"
                                    data-target="#modalConfirmacaoCancelamentoSeguro"
                                    onClick={() => this.selecionarReservasCancelarSeguro()}
                                    className="vx-remark-btn vx-remark-btn-seguro">
                                <span className="material-icons" style={{fontSize: '16px'}}>security</span>
                                Cancelar seguro
                            </button> : ''}
                    </div>
                </div>
            );
        }
        return '';
    }

    exibirTabelaReservas() {
        if (this.props.reservas && this.props.reservas.length) {
            return (
                <div id='tabela-pedidos'>
                    <div className="vx-remark-table-header">
                        <div>Empresa</div>
                        <div>Passageiro / CPF</div>
                        <div>Embarque</div>
                        <div>Origem → Destino</div>
                        <div>Situação</div>
                        <div>Poltrona</div>
                        <div>Ações</div>
                    </div>
                    <div>
                        {this.exibirReservas()}
                    </div>
                </div>
            );
        }
        return (
            <div className="vx-remark-empty">
                <span className="material-icons vx-remark-empty-icon">not_interested</span>
                <p className="vx-remark-empty-text">Nenhuma reserva localizada. Verifique os parâmetros informados.</p>
            </div>
        );
    }

    render() {
        return (
            <div className="row internas">
                <Titulo texto="Remarcação/Cancelamento de passagem" urlRetorno="/"/>
                <div className="col-12 conteudo-internas conteudo-painel">
                    {this.exibirTipoBusca()}
                    <Autorizacao
                        perfisPermitidos={[getAdminEmpresa(this.props.empresaSelecionada.id),
                            getOperadorRemarcacao(this.props.empresaSelecionada.id), PERFIL_ADMIN]}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        {this.exibirBotoes()}
                    </Autorizacao>
                    {this.exibirTabelaReservas()}
                    <ModalConfirmacaoCancelamentoReserva
                        buscarPedidos={this.buscarPedidos.bind(this)}
                        habilitadoZerarValorMultaCancelamento={this.state.habilitadoZerarValorMultaCancelamento}
                        handleHabilitadoZerarValorMultaCancelamento={this.handleHabilitadoZerarValorMultaCancelamento.bind(this)}
                        limparHabilitadoZerarValorMultaCancelamento={this.limparHabilitadoZerarValorMultaCancelamento.bind(this)}
                    />
                    <ModalConfirmacaoCancelamentoSeguro buscarPedidos={this.buscarPedidos.bind(this)}/>
                    <ModalConfirmacaoReservaEmAberto buscarPedidos={this.buscarPedidos.bind(this)}/>
                    <ModalConfirmacaoReservasSolicitacaoReembolso buscarPedidos={this.buscarPedidos.bind(this)}/>
                    <ModalConfirmacaoReservasParaReembolsoEfetivado buscarPedidos={this.buscarPedidos.bind(this)}/>
                    <ModalAnexaDocumentoReservasParaReembolsoEfetivado buscarPedidos={this.buscarPedidos.bind(this)}/>
                </div>
            </div>
        );
    }
}


export const mapStateToProps = state => (
    {
        reservas: state.remarcacao.reservas,
        reservasSelecionadas: state.remarcacao.reservasSelecionadas,
        empresaSelecionada: state.empresaSelecionada,
        tipoPesquisa: selector(state, 'tipoPesquisa'),
        cpf: selector(state, 'cpf'),
        numeroPedido: selector(state, 'numeroPedido'),
        numeroBilhete: selector(state, 'numeroBilhete')
    });


export default withRouter(connect(mapStateToProps, {
    alterarMarcacaoReserva,
    buscarPedidoRemarcacao,
    limparReservasRemarcacao,
    selecionarReservasRemarcacao,
    limpaViagens,
    selecionarDestino,
    selecionarOrigem,
    adicionarPassageirosIda,
    adicionarPassageirosVolta,
    selecionarDescontoUsuario,
    adicionarFormasPagamento,
    selecionarViagemIda,
    selecionarViagemVolta,
    selecionaReservaReembolsoSolicitado,
    changeFieldValue
})(reduxForm({
    form: 'formRemarcacao',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(PainelGerenciarRemarcacao)));
